import { LitElement, html, css } from './-global.min.js';

class MtnProductGrid extends LitElement {
    static properties = {
        productHandle: {
            type: String,
            attribute: 'data-product-handle'
        },
        product: {
          type: Object
        }
    };

    constructor() {
        super();
        this.product = {};
        this.accessToken = "e4c9e63cefc7836262ccdbe8b7dde110";
    }

    connectedCallback() {
        super.connectedCallback();
        // console.log(this.productHandle);
        this.fetchProducts().catch(console.error);
    }

    async fetchProducts() {

        const query = `
        {
            productByHandle(handle: "${this.productHandle}") {
              id
              title
              vendor
              featuredImage {
                url(transform: {maxWidth: 200})
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    availableForSale
                  }
                }
              }
              artists: metafield(namespace: "mtn", key: "artists") {
                references(first: 50) {
                  edges {
                    node {
                      __typename
                      ... on Metaobject {
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
              tracks: metafield(namespace: "mtn", key: "tracklist") {
                id
                references(first: 50) {
                  edges {
                    node {
                      __typename
                      ... on Metaobject {
                        fields {
                          key
                          value
                          reference {
                            ... on GenericFile {
                              url
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        }
        `;

        try {
          const response = await fetch('https://mutingthenoise.myshopify.com/api/2024-10/graphql.json', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': this.accessToken
              },
              body: JSON.stringify({ query })
          });
          const json = await response.json();
          // console.log(json);
          this.product = json.data.productByHandle;
          this.requestUpdate(); // Request update to re-render
        } catch (error) {
          console.error('Error fetching products:', error);
        }
        this.render();
    }   


    // Rendering function with updated artist and track data handling
    render() {
      if (!this.product.tracks) return null;

      // Generate the vendor URL
      const vendorUrl = `/collections/vendors?q=${encodeURIComponent(this.product.vendor)}`;

      // Construct the product URL using the handle
      const productUrl = `/products/${this.productHandle}`;

      // Extract and join artist names
      const artists = this.product.artists?.references?.edges
          .map(artist => artist.node.fields.find(field => field.key === 'name').value)
          .join(', ') || '';

      // Determine availability based on the first variant
      const isAvailable = this.product.variants?.edges[0]?.node.availableForSale ?? false;

      // Generate the HTML for each track
      return html`
          ${this.product.tracks.references.edges.map((track, index) => {
              const trackFields = track.node.fields.reduce((acc, field) => {
                  acc[field.key] = field.value;
                  if (field.key === 'file' && field.reference) {
                      acc['referenceUrl'] = field.reference.url;
                  }
                  return acc;
              }, {});

              return html`
                  <div class="js-track">
                      <div class="tracklist__item"
                        data-id="${this.product.id.split('/')[this.product.id.split('/').length - 1]}-${index + 1}"
                        data-album_label="${this.product.vendor}"
                        data-album_label_url="${vendorUrl}"
                        data-album_artist="${artists}"
                        data-album_cover="${this.product.featuredImage?.url}"
                        data-album_id="${this.product.variants.edges[0].node.id.split('/')[this.product.variants.edges[0].node.id.split('/').length - 1]}"
                        data-title="${trackFields.title}"
                        data-duration="${trackFields.duration}"
                        data-preview="${trackFields.referenceUrl}"
                        data-artist="${artists.split(', ')[0]}"
                        data-album_title="${this.product.title}"
                        data-product_url="${productUrl}"
                        data-is_available="${isAvailable}"
                      ></div>
                  </div>
              `;
          })}
      `;
    }
}
customElements.define('mtn-product-tracks', MtnProductGrid);
